import { useEffect, useState } from "react";
import mammoth from "mammoth";

const ConditionsVente = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/docs/CGV_V2.docx")
      .then(res => res.arrayBuffer())
      .then(arrayBuffer => {
        mammoth.convertToHtml({ arrayBuffer })
          .then(result => {
            setContent(result.value);
          })
          .catch(err => console.error("Erreur conversion DOCX:", err));
      });
  }, []);

  return (
    <div>
      <div
        className="document-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default ConditionsVente;
